<template>
<section>
    <div class="modal animated fadeIn show oppay" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered ">
            <button name="closeModal" type="button" id="close" ref="close" class="close" data-dismiss="modal" @click.prevent="cancel"></button>
            <div class="row">
                <div class="col-12">
                    <div class="opt-content card">
                        <div ref="warning" class="opt-content-wrapper active pay-pane active p-4">

                            <div class="text-center">
                                <i class="title-icon warning"></i>
                            </div>

                            <h3 class="text-center">Unable to process transaction</h3>

                            <p v-if="hasMessage" class="mb-4" v-text="message"></p>
                            <p v-else class="mb-4">This transaction must have been completed, is invalid or does not exist.</p>

                            <div class="modal-body">
                                <div class="row m-0">
                                    <div v-if="failedFromStart == 'false' || !failedFromStart" class="col-12 px-0">
                                        <div v-if="failedFromStart == 'false' || !failedFromStart" class="form-group text-center mb-2 mt-3">
                                            <button type="button" class="btn app-bg-color" :style="appColor ? { background : appColor}: ''" @click.prevent="tryAgain"> Try Again</button>
                                        </div>

                                        <div class="form-group text-center mb-0 mt-4">
                                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="text-tiny gray" @click.prevent="continueToMerchant"> 
                                                {{ !failedFromStart ? '&larr; ' : ''  }}
                                            Back to merchant</a>
                                        </div>
                                    </div>

                                    <div v-else class="col-12 px-0">
                                        <div class="form-group text-center mb-0 mt-4">
                                            <a href="javascript:void(0)" style="font-size : 14px !important; text-decoration:none" class="btn app-bg-color" @click.prevent="continueToMerchant" :style="{ background : appColor }" > 
                                                {{ !failedFromStart ? '&larr; ' : ''  }}
                                            Back to merchant</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
/* eslint-disable */

export default {
    name: 'warning',
    created() {
        this.hasMessage = true;

        if(window.failedFromStart){
            this.failedFromStart = window.failedFromStart;
        }

        // console.log(this.$store.state);


        if (window.failedFromStartMessage) {
            this.message = window.failedFromStartMessage
        }
        
        if (window.raw && JSON.parse(window.raw).status) {
            var res =  JSON.parse(window.raw)
            if (res.data.errors.code != "04")
                this.hasMessage = true;

            // console.log(res);

            this.message = res.data.error.message || res.data.errors.message;
            if (!this.$store.state.options || res.data.client_info)
                this.appColor = this.$store.state.options.clientInfo ? this.$store.state.options.clientInfo.primary_button_color : res.data.client_info.appColor + " !important";
        }

        
    },
    data() {
        return {
            hasMessage: false,
            message: '',
            appColor: '',
            env: false,
            failedFromStart: '',
        }
    },
    methods: {
        cancel() {
            this.closeIframe();
        },
        tryAgain() {
            let ref = Date.now() + (Math.floor(Math.random() * 1000)).toString()
            const newRef = `${this.$store.state.payload.transaction.transaction_ref}-${ref}`; 
            this.$store.dispatch('transRef', newRef);
            // this.$store.dispatch('transRef', ref);
            this.$store.dispatch('isFailed', true);
            this.$router.push('popup');
        },
        continueToMerchant() {

            
            if (!window.raw) {
                var response = {
                    status: 'Failed',
                    message: this.message || "Could not locate errors",
                    data: null,
                }
            } else {
                var res = JSON.parse(window.raw)
                res && res.data ? delete res.data.client_info : '';
                res && res.data ? delete res.data.paymentoptions : '';

                var response = {
                    status: res ? res.status || "Failed" : "Failed",
                    message: this.message || (res && res.data ? res.data.message : 'No message from the server') || "Could not locate errors",
                    data: res && res.data ? res.data || null : null,
                }
            }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef

            if (window.failedFromStart == 'false') {
                response.reference = this.$store.state.transRef || null;
                response.optionsTransRef = this.$store.state.options.optionsTransRef || null;
                response.paymentmethod = this.$store.state.paymentMethod || null;
            }

            this.$store.replaceState({
                paymentMethod: 'CARD',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                hasOtp: false,
                isFailed: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });

            response.status = "Failed";
            window.parent.postMessage(JSON.stringify(response), '*');
            if(this.$route.name != 'popup')
                this.$router.push('/popup');
        },
        closeIframe() {
            this.$store.replaceState({
                paymentMethod: 'CARD',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                isFailed: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });

            
            if(this.$route.name != 'popup')
                this.$router.push('/popup');

            if (isIframe)
                window.parent.postMessage('close', '*');
            else
                console.log("Can only close in an iframe");

        }
    }
};
</script>

<style scoped>
.modal.oppay button.close {
    right: -50px;
}



</style>
